import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset scroll on navigation. When the URL carries a hash, scroll to that
 * element instead so deep links like /services#itad land correctly.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a frame for the target page to mount before measuring.
      requestAnimationFrame(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
